import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { EnvelopesListPage } from './EnvelopesListPage';
import { EnvelopeBuilderPage } from './EnvelopeBuilderPage';
import { EnvelopeReviewPage } from './EnvelopeReviewPage';
import { EnvelopeSentPage } from './EnvelopeSentPage';
import { EnvelopeDetailPage } from './EnvelopeDetailPage';

export function DocumentSignArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<EnvelopesListPage />} />
        <Route path="/envelope/:envelopeId" element={<EnvelopeBuilderPage />} />
        <Route path="/envelope/:envelopeId/review" element={<EnvelopeReviewPage />} />
        <Route path="/envelope/:envelopeId/sent" element={<EnvelopeSentPage />} />
        <Route path="/envelope/:envelopeId/detail" element={<EnvelopeDetailPage />} />
      </Routes>
    </ArcheLayout>
  );
}
